import { DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';
import { AppRoutingModule } from './app-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import {MatRadioModule} from '@angular/material/radio';

import { HTTP_INTERCEPTORS, provideHttpClient, withXsrfConfiguration } from '@angular/common/http';
import { AuthenticationGuard } from './guards/authentication.guard';
import { BYMD_AUTOSERVICE_XSRF_COOKIE, HEADER_X_XSRF_TOKEN } from './const/cookiesKeys';
import { AppService } from './services/app.service';
import { ComponentsModule } from './components/components.module';
import { AuthModule } from './auth/auth.module';

import { ErrorHandlerInterceptor } from './interceptor/interceptor';
import { CredentialHandlerInterceptor } from './interceptor/xsrfInterceptor';
import { ApplicationInsightsService } from './logger/application-insights-service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


registerLocaleData(localePt, 'pt-BR');

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [RouterModule.forRoot([]),
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        FormsModule,
        LayoutModule,
        PagesModule,
        AuthModule,
        MatDialogModule,
        MatRadioModule,
        ComponentsModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })],
        providers: [
        AuthenticationGuard,
        AppService,
        ApplicationInsightsService,
        { provide: HTTP_INTERCEPTORS, useClass: CredentialHandlerInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL'},
        provideHttpClient(withXsrfConfiguration({
            cookieName: BYMD_AUTOSERVICE_XSRF_COOKIE,
            headerName: HEADER_X_XSRF_TOKEN
        }))
    ] })
export class AppModule { }
